// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CardListStyles } from "@insite/content-library/Components/CardList";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

const wrapper: InjectableCss = {
    css: css`
        margin-top: 5px;
    `,
};

const loadingOverlay: InjectableCss = {
    css: css`
        min-height: 300px;
    `,
};

const notFoundWrapper: InjectableCss = {
    css: css`
        margin-top: 30px;
    `,
};

const cardList: CardListStyles = {
    gridContainer: {
        gap: 0,
        css: css`
            min-height: 300px;
            em {
                font-weight: bold;
                font-style: normal;
            }
        `,
    },
};

const centeringWrapper: InjectableCss = {
    css: css`
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
    `,
};

const spinner: InjectableCss = {
    css: css`
        margin: auto;
    `,
};

const cardTitleLink: LinkPresentationProps = {
    color: "primary",
    hoverStyle: {
        color: "secondary",
        textDecoration: "none",
    },
    typographyProps: { size: 18, weight: 900, lineHeight: "21px", transform: "uppercase", forwardAs: "h2" },
    css: css`
        ${getProp("theme.link.defaultProps.css")}
        margin-bottom: 10px;
    `,
};

export const productListStyles = {
    wrapper,
    loadingOverlay,
    notFoundWrapper,
    cardList,
    centeringWrapper,
    spinner,
    cardTitleLink,
};
